class Opportunity {
  constructor(
    id,
    name,
    pointOfSalesAlreadyUsed,
    pointOfSalesUsed,
    newOpen,
    installationDate,
    installationComment,
    calendlyLinkCsm,
    contactName,
    contactFirstName,
    contactEmail,
    stageValue,
    stageNumber,
    licenceDuration,
  ) {
    this._id = id;
    this._name = name;
    this._pointOfSalesAlreadyUsed = pointOfSalesAlreadyUsed;
    this._pointOfSalesUsed = pointOfSalesUsed;
    this._newOpen = newOpen;
    this._installationDate = installationDate;
    this._installationComment = installationComment;
    this._calendlyLinkCsm = calendlyLinkCsm;
    this._contactName = contactName;
    this._contactFirstName = contactFirstName;
    this._contactEmail = contactEmail;
    this._stageValue = stageValue;
    this._stageNumber = stageNumber;
    this._licenceDuration = licenceDuration;
  }

  isValid() {
    for (var item in this) {
      if (this[item] === null || this[item] === '' || this[item] === undefined) {
        return false;
      }
    }
    return true;
  }

  // getters
  getId() {
    return this._id;
  }

  getName() {
    return this._name;
  }

  getPointOfSalesAlreadyUsed() {
    return this._pointOfSalesAlreadyUsed;
  }

  getPointOfSalesUsed() {
    return this._pointOfSalesUsed;
  }

  getNewOpen() {
    return this._newOpen;
  }

  getInstallationDate() {
    return this._installationDate;
  }

  getInstallationComment() {
    return this._installationComment;
  }

  getCalendlyLinkCsm() {
    return this._calendlyLinkCsm;
  }

  getContactName() {
    return this._contactName;
  }

  getContactFirstName() {
    return this._contactFirstName;
  }

  getContactEmail() {
    return this._contactEmail;
  }

  getFullName() {
    const fullname = this._contactFirstName + ' ' + this._contactName;
    return fullname;
  }

  getStageValue() {
    return this._stageValue;
  }

  getStageNumber() {
    return this._stageNumber;
  }

  getLicenceDuration() {
    return this._licenceDuration;
  }

  // setters
  setId(newId) {
    this._id = newId;
    return this;
  }

  setName(newName) {
    this._name = newName;
    return this;
  }

  setPointOfSalesAlreadyUsed(newPointOfSalesAlreadyUsed) {
    this._pointOfSalesAlreadyUsed = newPointOfSalesAlreadyUsed;
    return this;
  }

  setPointOfSalesUsed(newPointOfSalesUsed) {
    this._pointOfSalesUsed = newPointOfSalesUsed;
    return this;
  }

  setNewOpen(newNewOpen) {
    this._newOpen = newNewOpen;
    return this;
  }

  setInstallationDate(newInstallationDate) {
    this._installationDate = newInstallationDate;
    return this;
  }

  setInstallationComment(newInstallationComment) {
    this._installationComment = newInstallationComment;
    return this;
  }

  setCalendlyLinkCsm(newCalendlyLinkCsm) {
    this._calendlyLinkCsm = newCalendlyLinkCsm;
    return this;
  }

  setContactName(newContactName) {
    this._contactName = newContactName;
    return this;
  }

  setContactFirstName(newContactFirstName) {
    this._contactFirstName = newContactFirstName;
    return this;
  }

  setContactEmail(newContactEmail) {
    this._contactEmail = newContactEmail;
    return this;
  }

  setStageValue(newStageValue) {
    this._stageValue = newStageValue;
    return this;
  }

  setStageNumber(newStageNumber) {
    this._stageNumber = newStageNumber;
    return this;
  }

  serialize() {
    return { ...this, '@type': 'Opportunity' };
  }

  clone() {
    return new Opportunity(
      this._id,
      this._name,
      this._pointOfSalesAlreadyUsed,
      this._pointOfSalesUsed,
      this._newOpen,
      this._installationDate,
      this._installationComment,
      this._calendlyLinkCsm,
      this._contactName,
      this._contactFirstName,
      this._contactEmail,
      this._stageValue,
      this._licenceDuration,
    );
  }

  static deserialize(raw) {
    return new Opportunity(
      raw._id,
      raw._name,
      raw._pointOfSalesAlreadyUsed,
      raw._pointOfSalesUsed,
      raw._newOpen,
      raw._installationDate,
      raw._installationComment,
      raw._calendlyLinkCsm,
      raw._contactName,
      raw._contactFirstName,
      raw._contactEmail,
      raw._stageValue,
      raw._licenceDuration,
    );
  }
}

export default Opportunity;



// WEBPACK FOOTER //
// ./src/models/SFModels/Opportunity.js